import React, { Component } from "react";
import "./YouTubePopup.css";
import Global from "../../Global";

class YouTubePopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: false,
      isBackdropOnClick: false,
      videoId: "",
      videoStartTime: 0,
      isLoop: false,
      isAutoplay: false,
      isMute: false,
      isControls: false,
    };

    this.handleBackdropOnClick = this.handleBackdropOnClick.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  componentWillMount() {
    var self = this;

    var url = Global.getAPI("popup-youtube");
    var self = this;
    fetch(url)
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Error API: footer");
        }
        return response.json();
      })
      .then(function(data) {
        self.setState({
          isVisible: data.isOn,
          videoId: data.videoId,
          videoStartTime: data.videoStartTime,
          isLoop: data.isLoop,
          isAutoplay: data.isAutoplay,
          isMute: data.isMute,
          isControls: data.isControls
        });
      });
  }

  handleBackdropOnClick() {
    const { isBackdropOnClick } = this.state;
    if (isBackdropOnClick) return;
    this.setState({ isBackdropOnClick: true }, () => {
      setTimeout(() => {
        this.setState({ isBackdropOnClick: false });
      }, 400);
    });
  }

  handleDismiss() {
    document.body.style.overflow = "unset";
    this.setState({ isVisible: false });
  }

  getYouTubeVideoURL() {
    const {
      videoId,
      videoStartTime,
      isAutoplay,
      isLoop,
      isMute,
      isControls,
    } = this.state;

    if (videoId === null || videoId === "") return null;

    let videoYouTubeURL = `https://www.youtube.com/embed/${videoId}`;

    const urlWithParams = new URL(videoYouTubeURL);

    urlWithParams.searchParams.set(
      "start",
      videoStartTime > 0 ? videoStartTime : 0
    );
    urlWithParams.searchParams.set("autoplay", isAutoplay ? "1" : "0");
    urlWithParams.searchParams.set("mute", isMute ? "1" : "0");
    urlWithParams.searchParams.set("controls", isControls ? "1" : "0");

    if (isLoop) {
      urlWithParams.searchParams.set("loop", "1");
      urlWithParams.searchParams.set("playlist", videoId);
    } else {
      urlWithParams.searchParams.set("loop", "0");
    }

    return urlWithParams.href;
  }

  render() {
    const { isBackdropOnClick, isVisible } = this.state;

    if (!isVisible) return null;

    const urlYouTubeVideo = this.getYouTubeVideoURL();

    return (
      <div>
        <div
          className="popup-youtube-backdrop"
          tabIndex="-1"
          onClick={this.handleBackdropOnClick}
        />

        <div
          className={`popup-youtube-wrapper ${
            isBackdropOnClick ? "scale" : ""
          }`}
        >
          <button className={`btn-dismiss`} onClick={this.handleDismiss}>
            <span />
          </button>

          <div className={`popup-youtube-container `}>
            <iframe
              className="youtube-popup-iframe"
              src={urlYouTubeVideo}
              title="YouTube video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    );
  }
}

export default YouTubePopup;
